import React, { useState, useEffect } from "react";
import { Result, Button, Spin } from 'antd';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import URLSearchParams from 'url-search-params';

import { history } from "../appRedux/store";
import CircularProgress from "../components/CircularProgress";

import { launchpadSignIn, resetSignInError } from "../appRedux/actions/Auth";

const Launchpad = ({ location, appLoading, loading, launchpadUserAuthentication, resetError, message }) => {

    const params = new URLSearchParams(location.search);
    const email = params.get('email');
    const session = params.get('session');

    useEffect(() => {
        if (session && session != "") {
            launchpadUserAuthentication(session);
        }
    }, []);

    return (
        appLoading ?
            <CircularProgress /> :
            <div className="gx-login-container">
                <div className="gx-login-content">

                    <div className="gx-launchpad-header">
                        <img src={require("assets/images/radiscan-logo.png")} alt="wieldy" title="wieldy" />
                    </div>
                    {
                        loading &&
                        <div style={{textAlign: "center", margin: "50px"}}>
                            <Spin size="large" tip="Loading..." />
                        </div>
                    }
                    {
                        message && message !== "" &&
                        < Result
                            status="warning"
                            title={``}
                            subTitle={message}
                            extra={
                                <Button type="primary" key="login"
                                    onClick={() => {
                                        resetError();
                                        history.push("/");
                                    }}>
                                    Go Login
                                </Button>
                            }
                        />
                    }
                </div>
            </div>
    );
}

const mapStateToProps = ({ auth }) => {
    const { appLoading, loading, authUser, message } = auth;
    return { appLoading, loading, authUser, message }
};

export const mapDispatchToProps = dispatch => ({
    launchpadUserAuthentication: bindActionCreators(launchpadSignIn, dispatch),
    resetError: bindActionCreators(resetSignInError, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Launchpad);